<template>
    <Wrapper>
        <Breadcrumb :items="breadcrumbItems" />

        <h1 class="lg:w-1/2 header-1 mt-4 sm:mt-12"><T t="privacy_policy.title" /></h1>

        <div v-for="(category, i) in categories" :key="`category-${i}`">
            <h2 class="lg:w-1/2 header-2 separator-border-top-line" :class="i === 0 ? 'mt-8' : 'mt-16 sm:mt-20'">
                {{ category.name }}
            </h2>

            <div class="grid grid-cols-12 base-responsive-gap mt-6">
                <div
                    v-for="document in documents.filter((d) => d.category.id === category.id)"
                    :key="`document-${document.id}`"
                    class="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3"
                >
                    <DocumentCard
                        :size="document.document_size"
                        :title="document.name"
                        :url="document.media.document"
                    />
                </div>
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
import DocumentCard from '@/components/Cards/DocumentCard/DocumentCard.vue';

export default {
    name: 'PrivacyInformation',
    components: {
        Wrapper,
        DocumentCard,
    },
    async asyncData({ $axios, i18n, redirect, localePath }) {
        if (i18n.locale === 'en') {
            return await redirect(307, localePath('/'));
        }

        let categories = [];
        let documents = [];

        await $axios
            .$get('/privacy-information')
            .then((res) => {
                documents = res.data;
                categories = documents.reduce((acc, curr) => {
                    if (!acc.find((x) => x.id === curr.category.id)) {
                        acc.push(curr.category);
                    }

                    return acc;
                }, []);
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('privacy_policy.title'), 'documents']);

        return {
            breadcrumbItems,
            categories,
            documents,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('privacy-policy.index'),
            meta: this.$getPageMetaData('privacy-policy.index'),
        };
    },
};
</script>

<style scoped></style>
